import React from 'react'
import images from '../../app/utlis/image'
import Heading from '../atoms/Heading/Heading'
import ProjectDisplay from '../molecules/ProjectDisplay/ProjectDisplay'
import AppsFaq from '../molecules/AppsFaq/AppsFaq'
import AppsRunning from '../molecules/AppsSupportComponents/AppsRunning/AppsRunning'
import ReliabilityHospitalDash from '../molecules/HospitalDashComponents/ReliabilityHospitalDash/ReliabilityHospitalDash'
import HospitalDashIdeaProject from '../molecules/HospitalDashComponents/HospitalDashIdeaProject/HospitalDashIdeaProject'
import HospitalKeyFeatures from '../molecules/HospitalDashComponents/HospitalKeyFeatures/HospitalKeyFeatures'
import DefaultFooter from '../organisms/DefaultFooter/DefaultFooter'
import AppsMaintenance from '../molecules/AppsSupportComponents/AppsMaintenance/AppsMaintenance'
import { getPageData, useData } from '../../app/helper/functions'
import { motion } from 'framer-motion'

// Animation variants
const fadeIn = {
  hidden: { opacity: 0 },
  visible: { 
    opacity: 1,
    transition: { duration: 0.6 }
  }
}

const slideInLeft = {
  hidden: { opacity: 0, x: -50 },
  visible: { 
    opacity: 1, 
    x: 0,
    transition: { duration: 0.7, ease: "easeOut" }
  }
}

const slideInRight = {
  hidden: { opacity: 0, x: 50 },
  visible: { 
    opacity: 1, 
    x: 0,
    transition: { duration: 0.7, ease: "easeOut" }
  }
}

const slideUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" }
  }
}

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.1
    }
  }
}

const HospitalDashPage = () => {
  const { data } = useData();
  const hospitalDashData = getPageData(data, 'hospitalDashPage');
  
  return (
    <div>
      <div className='bg-hospitalDash-bg bg-center bg-cover bg-no-repeat'>
        <div className='bg-blackTransparent'>
          <motion.div 
            className='flex flex-col md:flex-row pr-[10%] md:pr-[10%] pb-8 gap-6 pt-32 md:pt-52 px-4 md:px-0'
            initial="hidden"
            animate="visible"
            variants={staggerContainer}
          >
            <motion.img 
              src={images.HOSPITALBANNER} 
              className='z-10 w-full md:w-[60%]' 
              variants={slideInLeft}
            />
            <motion.div 
              className='text-white flex flex-col gap-2 relative text-center md:text-end justify-center items-center'
              variants={slideInRight}
            >
              <div className='font-bold text-3xl md:text-6xl mb-2'>{hospitalDashData.title}</div>
              <div className='font-normal text-lg md:text-2xl'>{hospitalDashData.description}</div>
            </motion.div>
          </motion.div>
        </div>
      </div>
      <div className='bg-darkGreyPrimary'>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          variants={slideUp}
        >
          <Heading className='bg-darkGreyPrimary pt-8 md:pt-12 px-4 md:px-0'
            subTitle='Why choose custom hospital dashboards?'
            text="Hospital dashboards are crucial for managing complex data in modern healthcare. Custom
            dashboards provide real-time information, streamline workflows, & facilitate quicker
            decision-making. Whether tracking patient flow, evaluating staff performance,
            or managing resources, our dashboards are tailored to meet your hospital's specific needs." />
        </motion.div>
        
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          variants={fadeIn}
        >
          <ReliabilityHospitalDash hospitalDashData={hospitalDashData}/>
        </motion.div>
        
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          variants={slideUp}
        >
          <Heading className='bg-darkGreyPrimary pt-8 md:pt-12 px-4 md:px-0'
            subTitle='How we develop hospital dashboards'
            text='Our approach to designing and implementing hospital dashboards is organized, making
                 sure your facility works better with instant access to data.' />
        </motion.div>
        
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.1 }}
          variants={fadeIn}
        >
          <HospitalDashIdeaProject hospitalDashData={hospitalDashData}/>
        </motion.div>
        
        <motion.div 
          className='pt-6 md:pt-10 bg-darkGreyPrimary px-4 md:px-0'
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          variants={slideUp}
        >
          <AppsRunning title='Key points of our hospital dashboards'
            subtitle='We offer custom hospital dashboards that support different hospital functions, including patient care, resource management, financial reporting, and compliance oversight.' />
        </motion.div>
        
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          variants={fadeIn}
        >
          <HospitalKeyFeatures hospitalDashData={hospitalDashData}/>
        </motion.div>
        
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          variants={fadeIn}
        >
          <ProjectDisplay />
        </motion.div>
        
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          variants={slideUp}
        >
          <AppsFaq />
        </motion.div>
        
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          variants={fadeIn}
        >
          <AppsMaintenance 
            bgImage='bg-maintenance-health-bg' 
            title='Start your website maintenance plan now' 
            subtitle="Don't let old software or security issues impact your website's success. We'll manage maintenance so you can concentrate on growth. Contact us today for the right plan." 
          />
        </motion.div>
        
        <DefaultFooter />
      </div>
    </div>
  )
}

export default HospitalDashPage
